export const TABS = {
  TEACHER: 'TEACHER',
  PLAY: 'PLAY',
  LEARNING: 'LEARNING',
  MORE: 'MORE',
};

export default {TABS};
